const MIN_READ_TIME_MINUTES = 2;

const PROJECT_TITLE_KEYWORDS = [
	'project',
	'overview',
	'poster',
	'brief',
	'scope',
	'plan',
	'launch',
	'strategy',
];

const titleContainsProjectKeyword = (contentTitle: string): boolean => {
	const lowerTitle = contentTitle.toLowerCase();
	return PROJECT_TITLE_KEYWORDS.some((keyword) => lowerTitle.includes(keyword));
};

/**
 * Determines whether the "Get Project Overview" skill action should be shown.
 *
 * Conditions:
 * - Must be a page (not a blogpost, whiteboard, database, etc.)
 * - Page title contains a project-related keyword, OR read time is at least 2 minutes
 * - Read time must not still be loading
 */
export const shouldShowGetProjectOverviewAction = ({
	contentType,
	contentTitle,
	readTime,
	readTimeLoading,
}: {
	contentType: string;
	contentTitle?: string;
	readTime?: number | null;
	readTimeLoading?: boolean;
}): boolean => {
	if (contentType !== 'page') {
		return false;
	}

	if (readTimeLoading) {
		return false;
	}

	if (contentTitle && titleContainsProjectKeyword(contentTitle)) {
		return true;
	}

	return (readTime ?? 0) >= MIN_READ_TIME_MINUTES;
};
